import { pdfSearchResultType, registerSearchResultType } from '@/core/search/export';
import { articleSearchResultType } from '@/modules/articles/export';
import { eventSearchResultType } from '@/modules/calendar/export';

registerSearchResultType('article', articleSearchResultType);
registerSearchResultType('event', eventSearchResultType);
registerSearchResultType('pdf', pdfSearchResultType);
